import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Container } from 'react-bootstrap'
import emailjs from '@emailjs/browser'
import Rami from '../Resourses/logo-rami.svg'
import Kive from '../Resourses/logo-kive.svg'
import NavbarPages from './Commonds/NavbarPages'
import './Commonds/HomeFormulario.css'

const serviceId =
  process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_2s8vdwe'
const templateId =
  process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_6owny6s'
const publicKey =
  process.env.REACT_APP_EMAILJS_PUBLIC_KEY || '197ygxSEGrRTw4UCW'

const USER_FORM_ORIGIN = 'Contacto'

const Contacto = () => {
  const [buttonSend, setButtonSend] = useState(true)
  const [formSent, setFormSent] = useState(false)
  const [sendError, setSendError] = useState(false)
  const [formSending, setFormSending] = useState(false)

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      userName: '',
      userForm: USER_FORM_ORIGIN,
      userTelephone: '',
      userEmail: '',
      userMessage: '',
    },
  })

  function sendEmail(_data, e) {
    e.preventDefault()
    setSendError(false)
    setButtonSend(false)
    setFormSending(true)

    emailjs
      .sendForm(serviceId, templateId, e.target, publicKey)
      .then(() => {
        reset({
          userName: '',
          userForm: USER_FORM_ORIGIN,
          userTelephone: '',
          userEmail: '',
          userMessage: '',
        })
        setFormSent(true)
        setFormSending(false)
        setTimeout(() => {
          setFormSent(false)
          setButtonSend(true)
        }, 7000)
      })
      .catch(() => {
        setSendError(true)
        setFormSending(false)
        setButtonSend(true)
      })
  }

  return (
    <Container className="mb-0 ">
      <NavbarPages className="p-0" />
      <div className="row">
        <div className="col-12 contactoContainer">
          <h2 className="contacto__titulo">FORMULARIO DE CONTACTO</h2>
          <p className=" contacto__text mb-0">
            Si necesitas contactarte con nosotros, completá el siguiente
            formulario y te respondemos a la brevedad
          </p>

          <form onSubmit={handleSubmit(sendEmail)}>
            <input type="hidden" {...register('userForm')} />
            <p className="contacto__titulo--form">Nombre</p>
            <input
              type="text"
              {...register('userName', {
                required: 'Ingresá tu nombre.',
                minLength: {
                  value: 3,
                  message: 'El nombre debe tener al menos 3 caracteres.',
                },
              })}
              className="contacto__input"
              autoComplete="name"
            />
            <p className="formInput__error contacto__field-msg">
              {errors.userName?.message}
            </p>

            <p className="contacto__titulo--form">E-mail</p>
            <input
              type="email"
              {...register('userEmail', {
                required: 'Ingresá tu correo electrónico.',
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'El formato del correo no es válido.',
                },
              })}
              className="contacto__input"
              autoComplete="email"
            />
            <p className="formInput__error contacto__field-msg">
              {errors.userEmail?.message}
            </p>

            <p className="contacto__titulo--form">Teléfono</p>
            <input
              type="tel"
              {...register('userTelephone', {
                required: 'Ingresá un número de teléfono.',
                minLength: {
                  value: 8,
                  message: 'El teléfono debe tener al menos 8 dígitos.',
                },
              })}
              className="contacto__input"
              autoComplete="tel"
            />
            <p className="formInput__error contacto__field-msg">
              {errors.userTelephone?.message}
            </p>

            <p className="contacto__titulo--form">Consulta</p>
            <textarea
              {...register('userMessage', {
                required: 'Escribí tu consulta.',
                minLength: {
                  value: 15,
                  message: 'La consulta debe tener al menos 15 caracteres.',
                },
              })}
              className="contacto__input contacto__textarea"
              rows={5}
            />
            <p className="formInput__error contacto__field-msg">
              {errors.userMessage?.message}
            </p>

            {formSending && (
              <p className="contacto__status contacto__status--sending">
                Enviando…
              </p>
            )}
            {formSent && (
              <p className="formInput__sent contacto__alert-msg">
                Mensaje enviado correctamente. Te responderemos a la brevedad.
                <br />
                Muchas gracias.
              </p>
            )}
            {sendError && (
              <p className="formInput__sentNo contacto__alert-msg">
                No se pudo enviar el mensaje. Verificá tu conexión o intentá de
                nuevo en unos minutos.
              </p>
            )}

            {buttonSend && (
              <button
                type="submit"
                className="button-rounded--outline"
                disabled={formSending}
              >
                Enviar
              </button>
            )}
          </form>

          <div className="qSomosContainer qSomosContainer__logos ">
            <img
              src={Kive}
              className="qSomosContainer__logos--item"
              alt="Kive"
            />
            <img
              src={Rami}
              className="qSomosContainer__logos--item"
              alt="Rami Cintas e Hilos"
            />
          </div>
        </div>
      </div>
    </Container>
  )
}

export default Contacto
